
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AnalyticsPage from "./pages/AnalyticsPage";
import Index from "./pages/Index";
import AllVacationsPage from "./pages/AllVacationsPage";
import DealsPage from "./pages/DealsPage";
import LuxuryPage from "./pages/LuxuryPage";
import RondreizenPage from "./pages/RondreizenPage";
import JongerenreizenPage from "./pages/JongerenreizenPage";
import ThemaPage from "./pages/ThemaPage";
import ReisaanbiederPage from "./pages/ReisaanbiederPage";
import ResultatenPage from "./pages/ResultatenPage";
import FavoritesComparisonPage from "./pages/FavoritesComparisonPage";
import Contact from "./pages/Contact";
import Disclaimer from "./pages/Disclaimer";
import PrivacyCookiebeleid from "./pages/PrivacyCookiebeleid";
import PatentDocs from "./pages/PatentDocs";
import NotFound from "./pages/NotFound";
import WintersportPage from "./pages/WintersportPage";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/alle-vakanties" element={<AllVacationsPage />} />
            <Route path="/deals" element={<DealsPage />} />
            <Route path="/luxe" element={<LuxuryPage />} />
            <Route path="/rondreizen" element={<RondreizenPage />} />
            <Route path="/wintersport" element={<WintersportPage />} />
            <Route path="/jongerenreizen" element={<JongerenreizenPage />} />
            <Route path="/thema" element={<ThemaPage />} />
            <Route path="/thema/reisaanbieder" element={<ReisaanbiederPage />} />
            <Route path="/resultaten" element={<ResultatenPage />} />
            <Route path="/favorieten-vergelijken" element={<FavoritesComparisonPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/admin-analytics" element={<AnalyticsPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy-cookiebeleid" element={<PrivacyCookiebeleid />} />
            <Route path="/patent-docs" element={<PatentDocs />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
